import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { API, environment } from '@core/envs';
import { ScheduleStatusModel } from '../../models/schedule/scheduleStatus';
import { ChecklistModel } from '../../models/checklist/checklist.model';
import { WorkshopModel } from '../../models/workshop/workshop.model';
import { QuotationScheduleDetailVO } from '../../models/quotation/quotation-schedule-detail.model';
import { StorageKeys } from '@core/enums';
import { SessionService } from '@agenda-customer-ui/data-access';
import { IResponseModel } from '@core/interface';

const transformationURL = environment.getRoute(API.transformation);
const checklistURL = environment.getRoute(API.checklist);
const schedulingURL = environment.getRoute(API.scheduling);

@Injectable()
export class StatusService {

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  getScheduledServicesStatusData(vin: string, status: Array<number>, country: string): Observable<IResponseModel<ScheduleStatusModel[]>> {
    const schedules = this.sessionService.getObject(StorageKeys.STATUS_SCHEDULES) as IResponseModel<ScheduleStatusModel[]>;

    if (schedules.response?.length && vin === schedules.response[0].vin) {
      console.log('Schedules from cache');
      return new Observable(data => data.next(schedules));
    }

    const url = `${schedulingURL}/schedules/v2/status`;
    return this.http.post<IResponseModel<ScheduleStatusModel[]>>(url, { vin, country, status: [status] }).pipe(
      map(data => {
        this.sessionService.setObject(StorageKeys.STATUS_SCHEDULES, data);
        return data;
      })
    );
  }

  getCustumerChecklistData(req: ScheduleStatusModel): Observable<IResponseModel<ChecklistModel[]>> {
    const url = `${checklistURL}/checklist/checklist-customer/${req.country}/${req.divisionId}/${req.dealerId}/${req.advisorId}/${req.scheduleDate}/${req.scheduleHour}`;
    return this.http.get<IResponseModel<ChecklistModel[]>>(url);
  }

  getStatusWorkshopBySchedule(schedule: ScheduleStatusModel): Observable<IResponseModel<WorkshopModel[]>> {
    const url = `${transformationURL}/schedules/status?advisor=${schedule.advisorId}&country=${schedule.country}&date=${schedule.scheduleDate}&dealer=${schedule.dealerId}&hour=${schedule.scheduleHour}`;
    return this.http.get<IResponseModel<WorkshopModel[]>>(url);
  }

  getScheduleQuotation(advisorId: number, scheduleDate: string, scheduleHour: number, dealerId: number, country: string): Observable<IResponseModel<QuotationScheduleDetailVO>> {
    let url = `${transformationURL}/quotations?advisor=${advisorId}&country=${country}`;
    url = url.concat(`&date=${scheduleDate}&dealer=${dealerId}&hour=${scheduleHour}`);
    return this.http.get<IResponseModel<QuotationScheduleDetailVO>>(url);
  }

}
